import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import Immutable from "immutable";
import InfoTooltip from "components/Common/InfoTooltip";
import ResponseSelector from "components/Common/ResponseSelector";

class GreetingResponseSelector extends React.PureComponent {
  render() {
    return (
      <div className="Greeting__chatResponse">
        <span className="Greeting__left-column__label">
          Follow Up Answer
          <InfoTooltip
            customClassName="Greeting__left-column__label--margin"
            blurb="This response will be displayed to the user when they open the chat."
            iconDefault="QuestionCircle"
            iconClicked="QuestionCircleFilled"
            absolute
            inModal
          />
        </span>
        <ResponseSelector
          responses={this.props.responses}
          tags={this.props.tags}
          placeholder="Search Answers"
          onDidUpdate={this.props.handleResponseSelector}
          preSelect={this.props.responses.find(response => response.id === this.props.getValue("responseId"))}
          fixed
          invalid={this.props.getValue("invalidFields").contains("responseId")}
          inModal
          introContentRef={this.props.introContentRef}
        />
      </div>
    );
  }
}

GreetingResponseSelector.propTypes = {
  responses: ImmutablePropTypes.list.isRequired,
  tags: ImmutablePropTypes.list,
  getValue: PropTypes.func.isRequired,
  handleResponseSelector: PropTypes.func.isRequired
};

GreetingResponseSelector.defaultProps = {
  tags: Immutable.List()
};

export default GreetingResponseSelector;
